import DemoCarApp1 from "../assets/images/DemoCarApp1.png";
import {Avatar} from "@mui/material";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import SlideImagesAngular from "./SlideImagesAngular";
import BuildCircleIcon from "@mui/icons-material/BuildCircle";
import React from "react";
import SlideImagesReact from "./SlideImagesReact";
import LanguageIcon from '@mui/icons-material/Language';


function ReactCarAppProject(){

    return (
        <div className="CarAppPresentation">

            <div className="profile" style={{display: "inline-flex",padding: "15px",  width: "100%",}}>

                <div className="car-project-img">
                    <img src={DemoCarApp1} className="my-picture" alt="my picture"
                         style={{width: "100%", marginTop: "28px",border:"1px solid black", padding: "5px",}}/>
                </div>


                <div className="profile"
                     style={{display: "inline-block",border:"1px solid black",marginTop: "28px",padding: "5px",marginLeft:"10px",backgroundColor:"#100720", color: "white", width: "100%",}}>
                    <div className="my-message">

                        <h2>Car Management App</h2>
                        <p>The task was to create a car rental service management app for a company that runs taxi
                            business in several cities. The system should allow customers to book online and see
                            list of available cars.

                            <div className="tech-detail" style={{marginTop: " 30px"}}>Technical Details</div>
                            <ul style={{padding: "25px", textAlign: "left"}}>
                                <li>Should have Signup & Login Page for users</li>
                                <li>Should have Admin Panel</li>
                                <li>Implement authentication & guide for different users</li>
                                <li>Use modern frameworks and technologies</li>
                                <li>Use MySQL for data storage</li>
                                <li>Use Postman Api to test your end-points</li>
                                <li>Use Junit5+Mockito to test your Backend</li>
                            </ul>
                        </p>
                    </div>

                </div>
            </div>



            <br/><br/><br/><br/><br/><br/>
            <div style={ {display:'inline-flex', justifyContent:'center', width:'100%',}}>

                <Avatar sx={{backgroundColor:"crimson"}}>
                    <PlayCircleOutlineIcon sx={{color:"#100720"}} />
                </Avatar>

                <div  style={{color:"#100720",fontWeight: "700",
                    fontSize: "1.2em", marginLeft:'10px',padding:"5px"}}>
                    VIEW PRESENTATION

                </div>

            </div>
            <br/><br/>

            <div className="container" style={{width:"100%" , justifyContent:"center"}}>
                <SlideImagesReact/>
            </div>
            <br/><br/><br/><br/>
            <div style={ {display:'inline-flex', justifyContent:'center', width:'100%',}}>

                <div  style={{color:"#100720",fontWeight: "700",borderRadius:"5px", backgroundColor:"lightgreen",
                    fontSize: "1.2em", marginLeft:'10px',padding:"10px"}}>
                    CLICK TO VIEW
                </div>
                <a href={`https://carhiringapp.netlify.app/`}>
                <Avatar style={{ backgroundColor:"green",
                    marginLeft:'10px',padding:"2px"}}>
                    <LanguageIcon/>
                </Avatar>
                </a>
            </div>
            <br/><br/><br/><br/>
            <div style={ {display:'inline-flex', justifyContent:'center', width:'100%',}}>
                <Avatar >
                    <BuildCircleIcon/>
                </Avatar>
                <div  style={{color:"#100720",fontWeight: "700",
                    fontSize: "1.2em", marginLeft:'10px',padding:"5px"}}>
                    TECH. & FRAMEWORKS
                </div>
            </div>



            <div className="payment-management-project"
                 style={{
                     width: "100%",
                     padding: "15px",
                     display: "inline-flex"
                 }}
            >

                <div className="pay-management-project" style={{
                    padding: "5px",
                    margin: "5px",
                    width: "100%",
                    backgroundColor: "#100720",
                    color: "white",
                    display: "inline-block",
                    fontWeight: "700",
                    fontSize: "1.8em",
                }}>
                    <div style={{textAlign: "left",
                        marginBottom: "15px",
                        padding:"10px",
                    }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor"
                             className="bi bi-gear-fill" viewBox="0 0 16 16" style={{marginRight:"15px"}}>
                            <path
                                d="M9.405 1.05c-.413-1.4-2.397-1.4-2.81 0l-.1.34a1.464 1.464 0 0 1-2.105.872l-.31-.17c-1.283-.698-2.686.705-1.987 1.987l.169.311c.446.82.023 1.841-.872 2.105l-.34.1c-1.4.413-1.4 2.397 0 2.81l.34.1a1.464 1.464 0 0 1 .872 2.105l-.17.31c-.698 1.283.705 2.686 1.987 1.987l.311-.169a1.464 1.464 0 0 1 2.105.872l.1.34c.413 1.4 2.397 1.4 2.81 0l.1-.34a1.464 1.464 0 0 1 2.105-.872l.31.17c1.283.698 2.686-.705 1.987-1.987l-.169-.311a1.464 1.464 0 0 1 .872-2.105l.34-.1c1.4-.413 1.4-2.397 0-2.81l-.34-.1a1.464 1.464 0 0 1-.872-2.105l.17-.31c.698-1.283-.705-2.686-1.987-1.987l-.311.169a1.464 1.464 0 0 1-2.105-.872l-.1-.34zM8 10.93a2.929 2.929 0 1 1 0-5.86 2.929 2.929 0 0 1 0 5.858z"/>
                        </svg>
                        Technologies & Tools
                    </div>

                    <div className="pay-management-project" style={{
                        textAlign: "left",
                        width: "100%",
                        fontWeight: "200",
                        marginBottom: "15px",
                        fontSize: "0.5em",
                        padding:"10px",
                    }}>
                        Intelij Ultimate
                    </div>

                    <div style={{
                        textAlign: "left",
                        width: "100%",
                        fontWeight: "200",
                        marginBottom: "15px",
                        fontSize: "0.5em",
                        padding:"10px",
                    }}>

                        Hibernate
                    </div>
                    <div style={{
                        textAlign: "left",
                        width: "100%",
                        fontWeight: "200",
                        marginBottom: "15px",
                        fontSize: "0.5em",
                        padding:"10px",
                    }}>
                        Webstrom
                    </div>
                    <div style={{
                        textAlign: "left",
                        width: "100%",
                        fontWeight: "200",
                        marginBottom: "15px",
                        fontSize: "0.5em",
                        padding:"10px",
                    }}>
                        MySQL Database
                    </div>
                    <div style={{
                        textAlign: "left",
                        width: "100%",
                        fontWeight: "200",
                        marginBottom: "15px",
                        fontSize: "0.5em",
                        padding:"10px",
                    }}>
                        Postman Api
                    </div>
                    <div style={{
                        textAlign: "left",
                        width: "100%",
                        fontWeight: "200",
                        marginBottom: "15px",
                        fontSize: "0.5em",
                        padding:"10px",
                    }}>
                        Github
                    </div>

                </div>
                <br/>
                <div className="pay-management-project" style={{
                    padding: "5px",
                    margin: "5px",
                    width: "100%",
                    backgroundColor: "#100720",
                    color: "white",
                    display: "inline-block",
                    fontWeight: "700",
                    fontSize: "1.8em",
                }}>

                    <div style={{
                        textAlign: "left",
                        marginBottom: "15px",
                        padding:"10px",
                    }}>
                             <span style={{marginRight: "15px"}}>
                           <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                                className="bi bi-columns-gap" viewBox="0 0 16 16"><path
                               d="M6 1v3H1V1h5zM1 0a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H1zm14 12v3h-5v-3h5zm-5-1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-5zM6 8v7H1V8h5zM1 7a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H1zm14-6v7h-5V1h5zm-5-1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1h-5z"/></svg>
                                 </span>
                        Frameworks
                    </div>

                    <div style={{
                        textAlign: "left",
                        width: "100%",
                        fontWeight: "200",
                        marginBottom: "15px",
                        fontSize: "0.5em",
                        padding:"10px",
                    }}>
                        React
                    </div>

                    <div style={{
                        textAlign: "left",
                        width: "100%",
                        fontWeight: "200",
                        marginBottom: "15px",
                        fontSize: "0.5em",
                        padding:"10px",
                    }}>

                        Spring Boot
                    </div>

                </div>

            </div>


        </div>
    )
}
export default ReactCarAppProject;
